
export const MAXIMUM_FILE_COUNT = 10;
export const MAXIMUM_FILE_SIZE = 104857600;

export const ALLOWED_FILE_TYPES = [
  { ext: [".jpg", ".jpeg", ".png", ".heic", ".webp"], name: "Images and photos" },
  { ext: [".pdf"], name: "PDF" },
  { ext: [".doc", ".docx"], name: "Word documents" },
];
const extensions = ALLOWED_FILE_TYPES.map((ft) => ft.ext).flat();
export const ALLOWED_EXTENSIONS = [...new Set<string>(extensions)];

export const CATEGORIES = [
  { name: "Government Issued Photo ID", group: "Identity" },
  { name: "Social Security card", group: "Identity" },
  { name: "Birth certificate", group: "Identity" },
  { name: "Tax returns", group: "Income" },
  { name: "W2 Forms", group: "Income" },
  { name: "Schedule C", group: "Income" },
  { name: "1099", group: "Income" },
  { name: "K-1s", group: "Income" },
  { name: "Paystubs", group: "Income" },
  { name: "Workers compensation", group: "Income" },
  { name: "Gifts", group: "Income" },
  { name: "Unemployment Benefits", group: "Income" },
  { name: "Veteran's Benefits", group: "Income" },
  { name: "GI Bill", group: "Income" },
  { name: "National Guard", group: "Income" },
  { name: "Military benefits/income", group: "Income" },
  { name: "Social Security Award Letter", group: "Income" },
  { name: "SSI Award Letter", group: "Income" },
  { name: "Unearned Income from Minors", group: "Income" },
  { name: "Disability Benefits other than Social Security", group: "Income" },
  { name: "TANF Award Letter", group: "Income" },
  { name: "Proof of Child Support", group: "Income" },
  { name: "Alimony or Spousal Support Award", group: "Income" },
  { name: "Trusts Income", group: "Income" },
  { name: "Annuity Income", group: "Income" },
  { name: "Inheritance Income", group: "Income" },
  { name: "Retirement Fund or Pension Income", group: "Income" },
  { name: "Insurance Policy Income", group: "Income" },
  { name: "Lottery Winning Income", group: "Income" },
  { name: "Real Estate Income", group: "Income" },
  { name: "Student Financial Aid Award Letter", group: "Income" },
  { name: "Grants or Scholarships", group: "Income" },
  { name: "Income from Assets", group: "Income" },
  { name: "Tribal Income", group: "Income" },
  { name: "Severance Pay", group: "Income" },
  { name: "Death Benefits", group: "Income" },
  { name: "Preference Verification", group: "Verifications" },
  { name: "Asset Verification", group: "Verifications" },
  { name: "Employment Verification", group: "Verifications" },
  { name: "Landlord Verification", group: "Verifications" },
  { name: "Other Income Verification", group: "Verifications" },
  { name: "IRS Forms", group: "Verifications" },
  { name: "Checking Account Bank Statements", group: "Assets" },
  { name: "Savings Account Bank Statements", group: "Assets" },
  { name: "Other bank and related financial accounts", group: "Assets" },
  { name: "Revocable Trust", group: "Assets" },
  { name: "Deed", group: "Assets" },
  { name: "Mortgage", group: "Assets" },
  { name: "Money Market Account Statement", group: "Assets" },
  { name: "Certificate of Deposit Statement", group: "Assets" },
  { name: "Stocks or Bonds", group: "Assets" },
  { name: "Mutual Funds", group: "Assets" },
  { name: "401k Statements and 403b Statements", group: "Assets" },
  { name: "IRA Statements", group: "Assets" },
  { name: "Lump Sum Pension", group: "Assets" },
  { name: "Keogh Account", group: "Assets" },
  { name: "Retirement/pension plan", group: "Assets" },
  { name: "Whole Life Insurance Policy", group: "Assets" },
  { name: "Cash on Hand", group: "Assets" },
  { name: "Proof of Disposed Assets", group: "Assets" },
  { name: "Other periodic payments", group: "Assets" },
  { name: "Other", group: "Assets" },
  { name: "Rent receipts", group: "Rental History" },
  { name: "Rental agreement", group: "Rental History" },
  { name: "Lease", group: "Rental History" },
  { name: "Pre Application", group: "Forms" },
  { name: "Full Application", group: "Forms" },
  { name: "Other", group: "Other" },
];
